import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { eFAACTCustomer } from './efaact-customer.model';

export const geteFAACTCustomer = createAction('[eFAACTCustomer/API] GET eFAACTCustomer');

export const puteFAACTCustomer = createAction(
    '[eFAACTCustomer/API] PUT eFAACTCustomer',
    props<{ JsonString: any }>()
);

export const loadeFAACTCustomers = createAction(
    '[eFAACTCustomer/API] Load eFAACTCustomers',
    props<{ eFAACTCustomers: any[] }>()
);

export const addeFAACTCustomer = createAction(
    '[eFAACTCustomer/API] Add eFAACTCustomer',
    props<{ eFAACTCustomer: eFAACTCustomer }>()
);

export const upserteFAACTCustomer = createAction(
    '[eFAACTCustomer/API] Upsert eFAACTCustomer',
    props<{ eFAACTCustomer: eFAACTCustomer }>()
);

export const addeFAACTCustomers = createAction(
    '[eFAACTCustomer/API] Add eFAACTCustomers',
    props<{ eFAACTCustomers: eFAACTCustomer[] }>()
);

export const upserteFAACTCustomers = createAction(
    '[eFAACTCustomer/API] Upsert eFAACTCustomers',
    props<{ eFAACTCustomers: eFAACTCustomer[] }>()
);

export const updateeFAACTCustomer = createAction(
    '[eFAACTCustomer/API] Update eFAACTCustomer',
    props<{ eFAACTCustomer: Update<eFAACTCustomer> }>()
);

export const updateeFAACTCustomers = createAction(
    '[eFAACTCustomer/API] Update eFAACTCustomers',
    props<{ eFAACTCustomers: Update<eFAACTCustomer>[] }>()
);

export const deleteeFAACTCustomer = createAction(
    '[eFAACTCustomer/API] Delete eFAACTCustomer',
    props<{ id: string }>()
);

export const deleteeFAACTCustomers = createAction(
    '[eFAACTCustomer/API] Delete eFAACTCustomers',
    props<{ ids: string[] }>()
);

export const cleareFAACTCustomers = createAction('[eFAACTCustomer/API] Clear eFAACTCustomers');
